import { get, post } from "./Http";



//用户查询getUserList
function getUserList(query) {
  return post('/ctx-portal/v1/user/query', query);
}

//用户更新
function updateUser(query) {
  return post('/ctx-portal/v1/user/update', query);
}


//用户更新2018.12.21
function updateUserInfo(query) {
  return post("/ctx-portal/v1/people/update", query)
}


//查询用户基本信息
function getUserById(query) {
  return get('/ctx-portal/v1/user/current', query);
}

// 批量添加公司用户关联
function addUserCorpList(list) {
  return post('/ctx-portal/v1/userCorp/addByUserId', list);
}

// 删除一个公司用户关联
function deleteByUserAndCorp(id) {
  return post('/ctx-portal/v1/userCorp/deleteByUserAndCorp', id);
}

// 批量删除公司用户关联
function deleteByUserAndCorpList(id) {
  return post('/ctx-portal/v1/userCorp/deleteByUserId', id);
}

// 根据用户id查询用户基本信息的新接口 2018/12/21
function getUserInfo(id) {
  return post('/ctx-portal/v1/people/queryById', { id: id })
}

// 查询当前用户能切换的机构
function queryMyUser(query) {
  return post('ctx-portal/v1/user/queryMyUser', query)
}

// 查询当前用户能切换的机构
function queryByService(query) {
  return post('ctx-portal/v1/user/queryByService', query)
}

// 切换登录机构
function changeUserOrg(params) {
  return post('ctx-portal/v1/operate/changeUser', params)
}

export default {
  getUserList,
  updateUser,
  getUserById,
  addUserCorpList,
  deleteByUserAndCorp,
  deleteByUserAndCorpList,
  getUserInfo,
  updateUserInfo,
  queryMyUser,
  queryByService,
  changeUserOrg,
}



// WEBPACK FOOTER //
// ./src/api/UserManagementApi.js